(function() {
  function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
      get: v,
      set: s,
      enumerable: true,
      configurable: true
    });
  }
  var $parcel$global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
  var $parcel$modules = {};
  var $parcel$inits = {};
  var parcelRequire = $parcel$global["parcelRequire5f74"];
  if (parcelRequire == null) {
    parcelRequire = function(id) {
      if (id in $parcel$modules) {
        return $parcel$modules[id].exports;
      }
      if (id in $parcel$inits) {
        var init = $parcel$inits[id];
        delete $parcel$inits[id];
        var module = {
          id: id,
          exports: {}
        };
        $parcel$modules[id] = module;
        init.call(module.exports, module, module.exports);
        return module.exports;
      }
      var err = new Error("Cannot find module '" + id + "'");
      err.code = "MODULE_NOT_FOUND";
      throw err;
    };
    parcelRequire.register = function register(id, init) {
      $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire5f74"] = parcelRequire;
  }
  var parcelRegister = parcelRequire.register;
  parcelRegister("5SWup", function(module, exports) {
    $parcel$export(module.exports, "isSwymBisAvailable", function() {
      return $448f5dad87ede000$export$cac796225ff578aa;
    });
    $parcel$export(module.exports, "onSwymBisAvailable", function() {
      return $448f5dad87ede000$export$858bae1b764ca9ee;
    });
    $parcel$export(module.exports, "subscribeForBackInStock", function() {
      return $448f5dad87ede000$export$65a9154226ebdd85;
    });
    var $YjNU1 = parcelRequire("YjNU1");
    function $448f5dad87ede000$var$isBisEnabledBySetting() {
      if (typeof window === "undefined") return false;
      return window.MBF?.settings?.enableBackInStock === true;
    }
    function $448f5dad87ede000$var$getRuntime() {
      if (!$448f5dad87ede000$var$isBisEnabledBySetting()) return null;
      return (0, $YjNU1.initSwymBis)();
    }
    const $448f5dad87ede000$export$597311bb5a89b43c = () => {
      const runtime = $448f5dad87ede000$var$getRuntime();
      return runtime ? runtime.ready() : Promise.resolve();
    };
    const $448f5dad87ede000$export$cac796225ff578aa = () => {
      const runtime = $448f5dad87ede000$var$getRuntime();
      return runtime ? runtime.isAvailable() : false;
    };
    const $448f5dad87ede000$export$858bae1b764ca9ee = callback => {
      const runtime = $448f5dad87ede000$var$getRuntime();
      return runtime ? runtime.onAvailable(callback) : () => {};
    };
    const $448f5dad87ede000$export$65a9154226ebdd85 = args => {
      const runtime = $448f5dad87ede000$var$getRuntime();
      if (!runtime) return Promise.reject(new Error("[swym-bis] disabled by theme setting enable_back_in_stock"));
      return runtime.subscribeForBackInStock(args);
    };
  });
  parcelRegister("YjNU1", function(module, exports) {
    $parcel$export(module.exports, "initSwymBis", function() {
      return $0b54f75990233cb1$export$23cdde14ed5ac142;
    });
    const $0b54f75990233cb1$var$ALLOWED_MEDIA = new Set([ "email", "sms" ]);
    const $0b54f75990233cb1$var$REQUIRED_PRODUCT_FIELDS = [ "epi", "empi", "du", "pr", "iu" ];
    const $0b54f75990233cb1$var$BACK_IN_STOCK_TOPIC = "backinstock";
    const $0b54f75990233cb1$var$MAILING_LIST_DISABLED_MESSAGE = "Swym mailing list opt-in is not enabled. Enable the mailing list feature in the Swym dashboard and the theme setting before sending addToMailingList: 1.";
    const $0b54f75990233cb1$var$MAILING_LIST_DISABLED_USER_MESSAGE = "Newsletter opt-in is not available right now. Untick the newsletter box and try again.";
    function $0b54f75990233cb1$var$deferCallback(callback) {
      if (typeof queueMicrotask === "function") {
        queueMicrotask(callback);
        return;
      }
      Promise.resolve().then(callback);
    }
    function $0b54f75990233cb1$var$normalizeSwymSuccessArgs(args) {
      if (!Array.isArray(args) || args.length === 0) return null;
      if (args.length === 1) return args[0];
      return args;
    }
    function $0b54f75990233cb1$var$stringifySwymCallbackValue(value) {
      if (value instanceof Error) return value.message || value.name || "Error";
      if (typeof value === "string") return value.trim() || "empty string";
      if (value === undefined) return "undefined";
      if (value === null) return "null";
      try {
        return JSON.stringify(value);
      } catch (_error) {
        return Object.prototype.toString.call(value);
      }
    }
    function $0b54f75990233cb1$var$getSwymObjectMessage(value) {
      const message = value.message || value.error || value.msg || value.description;
      if (typeof message === "string" && message.trim()) return message.trim();
      if (message && typeof message === "object") return $0b54f75990233cb1$var$stringifySwymCallbackValue(message);
      const responseText = value.responseText || value.response?.text;
      if (typeof responseText === "string" && responseText.trim()) try {
        const parsed = JSON.parse(responseText);
        return $0b54f75990233cb1$var$getSwymObjectMessage(parsed) || $0b54f75990233cb1$var$stringifySwymCallbackValue(parsed);
      } catch (_error) {
        return responseText.trim();
      }
      return "";
    }
    function $0b54f75990233cb1$var$normalizeSwymErrorArgs(args, context = {}) {
      const values = Array.isArray(args) ? args : [ args ];
      const firstDefined = values.find(value => value !== undefined && value !== null);
      const callbackArgs = values.map($0b54f75990233cb1$var$stringifySwymCallbackValue).join(", ");
      const contextDetails = Object.entries(context).filter(([, value]) => value !== undefined && value !== null && value !== "").map(([key, value]) => `${key}: ${$0b54f75990233cb1$var$stringifySwymCallbackValue(value)}`).join(", ");
      const suffixParts = [];
      if (callbackArgs) suffixParts.push(`callback args: ${callbackArgs}`);
      if (contextDetails) suffixParts.push(`request: ${contextDetails}`);
      const withDetails = message => {
        const normalizedMessage = typeof message === "string" && message.trim() ? message.trim() : "subscribeForProductAlert failed";
        const details = suffixParts.length ? ` (${suffixParts.join("; ")})` : "";
        const error = new Error(`[swym-bis] ${normalizedMessage}${details}`);
        error.swymCallbackArgs = values;
        error.swymRequestContext = context;
        return error;
      };
      if (firstDefined instanceof Error) {
        const error = withDetails(firstDefined.message || firstDefined.name);
        error.cause = firstDefined;
        return error;
      }
      if (typeof firstDefined === "string" && firstDefined.trim()) return withDetails(firstDefined);
      if (firstDefined && typeof firstDefined === "object") return withDetails($0b54f75990233cb1$var$getSwymObjectMessage(firstDefined));
      return withDetails();
    }
    function $0b54f75990233cb1$var$assertRuntime() {
      if (typeof window === "undefined") throw new Error("[swym-bis] window is unavailable");
    }
    function $0b54f75990233cb1$var$normalizeAndValidateProduct(product) {
      if (!product || typeof product !== "object") throw new Error("[swym-bis] product must be an object");
      for (const field of $0b54f75990233cb1$var$REQUIRED_PRODUCT_FIELDS) {
        if (!(field in product) || product[field] === null || product[field] === "") throw new Error(`[swym-bis] missing required product field "${field}"`);
      }
      const du = String(product.du).trim().split("#")[0].split("?")[0];
      if (!du) throw new Error("[swym-bis] product.du must be a valid canonical URL");
      return {
        epi: product.epi,
        empi: product.empi,
        du: du,
        pr: product.pr,
        iu: String(product.iu).trim()
      };
    }
    function $0b54f75990233cb1$var$validateMedium(mediumValue, medium) {
      if (!mediumValue || typeof mediumValue !== "string" || mediumValue.trim().length === 0) throw new Error("[swym-bis] mediumValue is required");
      if (!$0b54f75990233cb1$var$ALLOWED_MEDIA.has(medium)) throw new Error('[swym-bis] medium must be either "email" or "sms"');
    }
    function $0b54f75990233cb1$var$isMailingListOptInEnabled() {
      return window.MBF?.settings?.enableBackInStockMailingList === true;
    }
    function $0b54f75990233cb1$var$createSwymBisRuntime() {
      let swatRef = null;
      const availableCallbacks = new Set;
      let readyResolve;
      const readyPromise = new Promise(resolve => {
        readyResolve = resolve;
      });
      const hasBisSubscribeCapability = () => Boolean(swatRef && typeof swatRef.subscribeForProductAlert === "function");
      const setReady = swat => {
        if (!swat || swatRef) return;
        swatRef = swat;
        readyResolve();
        if (!hasBisSubscribeCapability()) return;
        availableCallbacks.forEach(callback => callback());
        availableCallbacks.clear();
      };
      if (window._swat) setReady(window._swat);
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(setReady);
      return {
        ready() {
          return readyPromise;
        },
        isAvailable() {
          return hasBisSubscribeCapability();
        },
        onAvailable(callback) {
          if (typeof callback !== "function") return () => {};
          if (hasBisSubscribeCapability()) {
            callback();
            return () => {};
          }
          availableCallbacks.add(callback);
          return () => availableCallbacks.delete(callback);
        },
        async subscribeForBackInStock({mediumValue: mediumValue, medium: medium = "email", product: product, addToMailingList: addToMailingList = 0} = {}) {
          $0b54f75990233cb1$var$validateMedium(mediumValue, medium);
          const normalizedProduct = $0b54f75990233cb1$var$normalizeAndValidateProduct(product);
          const normalizedAddToMailingList = Number(addToMailingList) === 1 ? 1 : 0;
          if (normalizedAddToMailingList === 1 && !$0b54f75990233cb1$var$isMailingListOptInEnabled()) {
            const error = new Error(`[swym-bis] ${$0b54f75990233cb1$var$MAILING_LIST_DISABLED_MESSAGE}`);
            error.userMessage = $0b54f75990233cb1$var$MAILING_LIST_DISABLED_USER_MESSAGE;
            error.swymRequestContext = {
              medium: medium,
              product: normalizedProduct,
              addToMailingList: normalizedAddToMailingList,
              topic: $0b54f75990233cb1$var$BACK_IN_STOCK_TOPIC
            };
            throw error;
          }
          await readyPromise;
          return new Promise((resolve, reject) => {
            let settled = false;
            const resolveOnce = value => {
              if (settled) return;
              settled = true;
              resolve(value);
            };
            const rejectOnceDeferred = (...errorArgs) => {
              const normalizedError = $0b54f75990233cb1$var$normalizeSwymErrorArgs(errorArgs, {
                medium: medium,
                product: normalizedProduct,
                addToMailingList: normalizedAddToMailingList,
                topic: $0b54f75990233cb1$var$BACK_IN_STOCK_TOPIC
              });
              $0b54f75990233cb1$var$deferCallback(() => {
                if (settled) return;
                settled = true;
                reject(normalizedError);
              });
            };
            swatRef.subscribeForProductAlert(mediumValue.trim(), medium, normalizedProduct, (...successArgs) => resolveOnce($0b54f75990233cb1$var$normalizeSwymSuccessArgs(successArgs)), (...errorArgs) => rejectOnceDeferred(...errorArgs), normalizedAddToMailingList, $0b54f75990233cb1$var$BACK_IN_STOCK_TOPIC);
          });
        }
      };
    }
    function $0b54f75990233cb1$export$23cdde14ed5ac142() {
      $0b54f75990233cb1$var$assertRuntime();
      window.MBF = window.MBF || {};
      if (window.MBF.swymBis) return window.MBF.swymBis;
      const runtime = $0b54f75990233cb1$var$createSwymBisRuntime();
      window.MBF.swymBis = runtime;
      return runtime;
    }
  });
  var $5SWup = parcelRequire("5SWup");
  const $53749dcc4d5e26d1$var$PRODUCT_FORM_REQUEST_CURRENT_STATE_EVENT = "product-form:request-current-state";
  const $53749dcc4d5e26d1$var$escapeSelector = value => {
    const stringValue = String(value ?? "");
    if (window.CSS?.escape) return window.CSS.escape(stringValue);
    return stringValue.replace(/["\\]/g, "\\$&");
  };
  const $53749dcc4d5e26d1$var$parseSourceJson = sourceJson => {
    if (!sourceJson) return null;
    try {
      return JSON.parse(sourceJson);
    } catch (error) {
      console.warn("[notify-drawer] Failed to parse modal source metadata", error);
      return null;
    }
  };
  const $53749dcc4d5e26d1$var$resolveImageUrl = image => {
    if (!image) return "";
    if (typeof image === "string") return image;
    if (typeof image === "object") return image.src || image.url || "";
    return "";
  };
  const $53749dcc4d5e26d1$var$getShopBaseUrl = () => {
    const shopDomain = window.Shopify?.shop;
    if (typeof shopDomain !== "string" || !shopDomain.trim()) return window.location.origin;
    const normalizedDomain = shopDomain.trim().replace(/^https?:\/\//, "");
    return `https://${normalizedDomain}`;
  };
  const $53749dcc4d5e26d1$var$resolveAbsoluteUrl = (value, {stripSearch: stripSearch = false, stripHash: stripHash = false} = {}) => {
    const rawValue = String(value ?? "").trim();
    if (!rawValue) return "";
    try {
      const url = new URL(rawValue, $53749dcc4d5e26d1$var$getShopBaseUrl());
      if (stripSearch) url.search = "";
      if (stripHash) url.hash = "";
      return url.toString();
    } catch (_error) {
      return "";
    }
  };
  var $53749dcc4d5e26d1$export$2e2bcd8739ae039 = (() => {
    if (customElements.get("notify-drawer")) return;
    customElements.define("notify-drawer", class NotifyDrawer extends HTMLElement {
      submitting=false;
      currentVariantId=null;
      sourceFormEl=null;
      latestSharedPayload=null;
      constructor() {
        super();
        this.onSourceVariantChange = this.onSourceVariantChange.bind(this);
        this.onSourceStateUpdated = this.onSourceStateUpdated.bind(this);
        this.onDrawerOptionChange = this.onDrawerOptionChange.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.onSwymAvailable = this.onSwymAvailable.bind(this);
      }
      connectedCallback() {
        this.cacheElements();
        this.resolveSourceForm();
        this.bindEvents();
        this.syncFromSource();
      }
      disconnectedCallback() {
        this.formEl?.removeEventListener("submit", this.onFormSubmit);
        this.emailInputEl?.removeEventListener("input", this.onInputChange);
        this.emailInputEl?.removeEventListener("change", this.onInputChange);
        this.newsletterInputEl?.removeEventListener("change", this.onInputChange);
        this.optionsEl?.removeEventListener("change", this.onDrawerOptionChange);
        this.sourceFormEl?.removeEventListener("variant:change", this.onSourceVariantChange);
        this.sourceFormEl?.removeEventListener("product-form:state-updated", this.onSourceStateUpdated);
        this.swymAvailabilityUnsubscribe?.();
        this.swymAvailabilityUnsubscribe = null;
      }
      cacheElements() {
        this.modalContainerEl = this.closest("[data-locker-container]");
        this.formEl = this.querySelector("[data-nd-form]");
        this.emailInputEl = this.querySelector("[data-nd-email]");
        this.newsletterInputEl = this.querySelector("[data-nd-newsletter]");
        this.variantIdInputEl = this.querySelector("[data-nd-variant-id]");
        this.optionsEl = this.querySelector("[data-nd-options]");
        this.errorEl = this.querySelector("[data-nd-error]");
        this.successEl = this.querySelector("[data-nd-success]");
        this.submitButtonEl = this.querySelector("[data-nd-submit]");
        this.submitTextEl = this.querySelector("[data-nd-submit-text]");
        this.defaultSubmitText = this.submitTextEl?.textContent?.trim() || "Translation missing: en.product.out_of_stock.submit";
        this.defaultErrorText = this.errorEl?.textContent?.trim() || "";
      }
      resolveSourceForm() {
        const source = $53749dcc4d5e26d1$var$parseSourceJson(this.modalContainerEl?.dataset.modalSourceJson);
        const sourceFormId = source?.formId || source?.id || this.modalContainerEl?.dataset.modalSourceId;
        const productId = source?.productId || this.dataset.ndProductId;
        if (sourceFormId) {
          const escapedFormId = $53749dcc4d5e26d1$var$escapeSelector(sourceFormId);
          this.sourceFormEl = document.querySelector(`product-form[form="${escapedFormId}"]`);
        }
        if (!this.sourceFormEl && productId) {
          const escapedProductId = $53749dcc4d5e26d1$var$escapeSelector(productId);
          this.sourceFormEl = document.querySelector(`product-form[data-product-id="${escapedProductId}"]`);
        }
      }
      bindEvents() {
        this.formEl?.addEventListener("submit", this.onFormSubmit);
        this.emailInputEl?.addEventListener("input", this.onInputChange);
        this.emailInputEl?.addEventListener("change", this.onInputChange);
        this.newsletterInputEl?.addEventListener("change", this.onInputChange);
        this.optionsEl?.addEventListener("change", this.onDrawerOptionChange);
        this.sourceFormEl?.addEventListener("variant:change", this.onSourceVariantChange);
        this.sourceFormEl?.addEventListener("product-form:state-updated", this.onSourceStateUpdated);
        this.swymAvailabilityUnsubscribe = (0, $5SWup.onSwymBisAvailable)(this.onSwymAvailable);
      }
      onSourceVariantChange(event) {
        this.clearFeedback();
        this.applySharedPayload(event.detail?.payload || event.detail || null);
      }
      onSourceStateUpdated(event) {
        this.applySharedPayload(event.detail?.payload || event.detail || null);
      }
      onDrawerOptionChange(event) {
        const optionInput = event.target.closest('input[name^="option"]');
        if (!optionInput || !this.sourceFormEl) return;
        const escapedName = $53749dcc4d5e26d1$var$escapeSelector(optionInput.name);
        const escapedValue = $53749dcc4d5e26d1$var$escapeSelector(optionInput.value);
        const sourceInput = this.sourceFormEl.querySelector(`input[name="${escapedName}"][value="${escapedValue}"]`);
        if (!sourceInput || sourceInput.checked) return;
        sourceInput.click();
      }
      onInputChange() {
        this.clearFeedback();
      }
      syncFromSource() {
        const sourceVariant = this.sourceFormEl?.currentVariant || null;
        if (sourceVariant) this.syncVariant(sourceVariant, sourceVariant.options || []);
        this.sourceFormEl?.dispatchEvent(new CustomEvent($53749dcc4d5e26d1$var$PRODUCT_FORM_REQUEST_CURRENT_STATE_EVENT));
      }
      applySharedPayload(payload) {
        if (!payload || typeof payload !== "object") return;
        const variant = payload.variant || null;
        const options = Array.isArray(payload.options) ? payload.options : variant?.options || [];
        this.latestSharedPayload = payload;
        if (!variant) return;
        this.syncVariant(variant, options);
      }
      syncVariant(variant, selectedOptions = []) {
        if (!variant) return;
        this.currentVariantId = String(variant.id);
        if (this.variantIdInputEl) this.variantIdInputEl.value = this.currentVariantId;
        this.syncOptionInputs(selectedOptions);
        this.updateStaticDespatchMessages();
      }
      syncOptionInputs(selectedOptions) {
        if (!this.optionsEl || !Array.isArray(selectedOptions)) return;
        selectedOptions.forEach((optionValue, index) => {
          const optionName = `option${index + 1}`;
          const escapedName = $53749dcc4d5e26d1$var$escapeSelector(optionName);
          const escapedValue = $53749dcc4d5e26d1$var$escapeSelector(optionValue);
          const target = this.optionsEl.querySelector(`input[name="${escapedName}"][value="${escapedValue}"]`);
          if (target) target.checked = true;
        });
      }
      onSwymAvailable() {
        this.updateStaticDespatchMessages();
      }
      updateStaticDespatchMessages() {
        if (!this.optionsEl) return;
        const bisAvailable = (0, $5SWup.isSwymBisAvailable)();
        const notifyText = window.MBF?.strings?.outOfStock?.notifyLong || "Translation missing: en.product.out_of_stock.notify_long";
        this.optionsEl.querySelectorAll("[data-static-despatch-message]").forEach(messageEl => {
          const isNotifyMessage = messageEl.dataset.staticDespatchIsNotify === "true";
          if (!isNotifyMessage) return;
          messageEl.textContent = bisAvailable ? notifyText : "";
        });
      }
      getNotifyProductPayload() {
        const notifyPayload = this.latestSharedPayload?.notify?.product || {};
        const variant = this.latestSharedPayload?.variant || this.sourceFormEl?.currentVariant || null;
        if (!variant) return null;
        const product = this.latestSharedPayload?.product || {};
        const productId = notifyPayload.empi ?? product.id ?? this.sourceFormEl?.dataset?.productId;
        const productUrl = $53749dcc4d5e26d1$var$resolveAbsoluteUrl(notifyPayload.du ?? product.url ?? this.sourceFormEl?.dataset?.url ?? window.location.pathname, {
          stripSearch: true,
          stripHash: true
        });
        const imageUrl = $53749dcc4d5e26d1$var$resolveAbsoluteUrl(notifyPayload.iu ?? $53749dcc4d5e26d1$var$resolveImageUrl(variant.featured_image) ?? $53749dcc4d5e26d1$var$resolveImageUrl(this.latestSharedPayload?.product?.featured_image)) || "";
        if (!productUrl || !imageUrl || productId === undefined || productId === null) return null;
        return {
          epi: notifyPayload.epi ?? variant.id,
          empi: productId,
          du: productUrl,
          pr: notifyPayload.pr ?? variant.price,
          iu: imageUrl
        };
      }
      setSubmittingState(isSubmitting) {
        this.submitting = isSubmitting;
        if (this.submitButtonEl) this.submitButtonEl.disabled = isSubmitting;
        if (this.submitTextEl) this.submitTextEl.textContent = isSubmitting ? window.MBF?.strings?.adding || this.defaultSubmitText : this.defaultSubmitText;
      }
      clearFeedback() {
        if (this.errorEl && this.defaultErrorText) this.errorEl.textContent = this.defaultErrorText;
        this.errorEl?.classList.add("hidden");
        this.successEl?.classList.add("hidden");
      }
      showError(message = "") {
        this.successEl?.classList.add("hidden");
        if (this.errorEl && message) this.errorEl.textContent = message;
        this.errorEl?.classList.remove("hidden");
      }
      showSuccess() {
        this.errorEl?.classList.add("hidden");
        this.successEl?.classList.remove("hidden");
      }
      async onFormSubmit(event) {
        event.preventDefault();
        if (!this.formEl || this.submitting) return;
        this.clearFeedback();
        if (!this.formEl.reportValidity()) {
          this.showError();
          return;
        }
        const variantId = this.variantIdInputEl?.value || this.currentVariantId;
        const productPayload = this.getNotifyProductPayload();
        const email = this.emailInputEl?.value?.trim() || "";
        const addToMailingList = this.newsletterInputEl?.checked ? 1 : 0;
        if (!productPayload || !email) {
          this.showError();
          return;
        }
        this.setSubmittingState(true);
        try {
          await (0, $5SWup.subscribeForBackInStock)({
            mediumValue: email,
            medium: "email",
            product: productPayload,
            addToMailingList: addToMailingList
          });
          this.showSuccess();
          this.formEl.reset();
          if (this.variantIdInputEl) this.variantIdInputEl.value = variantId;
        } catch (error) {
          console.warn("[notify-drawer] BIS subscription failed", error?.message || error, {
            swymCallbackArgs: error?.swymCallbackArgs,
            swymRequestContext: error?.swymRequestContext
          });
          this.showError(error?.userMessage);
        } finally {
          this.setSubmittingState(false);
        }
      }
    });
  })();
})();